import { useState } from 'react';
import { exportToCSV } from '@services/export/csv-export';
import { logger } from '@utils/logger';

export function useExport() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const exportCSV = async (sessionIds: string[]): Promise<void> => {
    try {
      setLoading(true);
      setError(null);
      await exportToCSV(sessionIds);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'CSV export failed';
      logger.error('CSV export error:', err);
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    exportCSV,
    loading,
    error,
  };
}
